// API'den gelen veriler için boş fallback
export const octoberCMSData = {
  siteSettings: {},
  vehicles: [],
  services: [],
  contact: {},
  socialMedia: {}
};

// OctoberCMS API'den veri alma
export const fetchOctoberCMSData = () => {
  console.log('API çağrısı başlatılıyor...');
  
  return new Promise((resolve, reject) => {
    // Environment variable'dan API URL'yi al
    const apiUrl = process.env.REACT_APP_API_URL || 'https://agaclandirmaseferberligi.com/api/data-v2';
    console.log('Fetching from:', apiUrl);
    
    fetch(apiUrl)
      .then(response => {
        console.log('API Response status:', response.status);
        if (response.ok) {
          return response.text();
        }
        throw new Error(`API yanıt vermedi: ${response.status}`);
      })
      .then(responseText => {
        // JSON'daki kontrol karakterlerini temizle
        const cleanedText = responseText.replace(/[\x00-\x1F\x7F]/g, '');
        
        try {
          const apiData = JSON.parse(cleanedText);
          console.log('Toyota API\'den veriler alındı:', apiData);
          
          // API verilerini fallback verilerle birleştir
          const mergedData = mergeWithFallback(apiData);
          resolve(mergedData);
        } catch (parseError) {
          console.error('JSON parse hatası:', parseError);
          console.log('Problematik JSON (ilk 1000 karakter):', responseText.substring(0, 1000));
          throw parseError;
        }
      })
      .catch(error => {
        console.error('Toyota API hatası:', error);
        // API çalışmazsa boş veri döndür
        resolve({
          siteSettings: {},
          sliders: [],
          trees: [],
          goals: [],
          videos: [],
          gallery: [],
          vehicles: [],
          services: [],
          faqs: [],
          contact: {},
          socialMedia: {}
        });
      });
  });
};

// Fotoğraf URL'sine base path ekle
const addImageBasePath = (url) => {
  if (!url) return '';
  // Eğer zaten tam URL ise (http:// veya https:// ile başlıyorsa) olduğu gibi döndür
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Eğer / ile başlıyorsa base path ekle
  const basePath = 'https://agaclandirmaseferberligi.com/api/storage/app/media';
  // URL'deki başlangıç slash'ini temizle
  const cleanUrl = url.startsWith('/') ? url.substring(1) : url;
  return `${basePath}/${cleanUrl}`;
};

// Galeri API'den veri alma
export const fetchGalleryAPI = () => {
  return new Promise((resolve, reject) => {
    const apiUrl = 'https://agaclandirmaseferberligi.com/api/gallery-api.json';
    
    fetch(apiUrl)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Galeri API yanıt vermedi: ${response.status}`);
      })
      .then(data => {
        // gallery field'ını parse et ve URL'lere base path ekle
        const parsedData = data.map(item => {
          let gallery = [];
          if (item.gallery) {
            try {
              // JSON string'i parse et
              let galleryStr = item.gallery;
              // Eğer string ise parse et
              if (typeof galleryStr === 'string') {
                // Escape karakterlerini düzelt - önce çift backslash'leri tek yap
                galleryStr = galleryStr.replace(/\\\\/g, '\\');
                // Sonra parse et
                gallery = JSON.parse(galleryStr);
              } else {
                gallery = galleryStr;
              }
            } catch (e) {
              console.error('Galeri parse hatası:', e, item.gallery);
              // Hata durumunda boş array döndür
              gallery = [];
            }
          }
          
          // Cover ve gallery URL'lerine base path ekle
          const coverUrl = addImageBasePath(item.cover);
          const galleryUrls = gallery.map(g => {
            const slideUrl = typeof g === 'string' ? g : (g.slide || g);
            const fullUrl = addImageBasePath(slideUrl);
            // Eğer object ise slide property'sini güncelle, değilse direkt URL döndür
            if (typeof g === 'object' && g !== null) {
              return {
                ...g,
                slide: fullUrl
              };
            }
            return fullUrl;
          });
          
          return {
            ...item,
            cover: coverUrl,
            gallery: galleryUrls
          };
        });
        console.log('Galeri verileri parse edildi:', parsedData);
        resolve(parsedData);
      })
      .catch(error => {
        console.error('Galeri API hatası:', error);
        resolve([]);
      });
  });
};

// API verilerini doğrudan kullan
function mergeWithFallback(apiData) {
  return {
    siteSettings: apiData.siteSettings || {},
    sliders: apiData.sliders || [],
    trees: apiData.trees || [],
    goals: apiData.goals || [],
    videos: apiData.videos || [],
    gallery: apiData.gallery || [],
    vehicles: apiData.vehicles || [],
    services: apiData.services || [],
    faqs: apiData.faqs || [],
    contact: apiData.contact || {},
    socialMedia: apiData.socialMedia || {}
  };
}
